export default "__VITE_ASSET__D_g1NQ3p__"